






import Vue from 'vue';
import ErrorBoundary from '@/containers/globals/ErrorBoundary.vue';

export default Vue.extend({
  components: { ErrorBoundary },
});
